const menus = document.querySelectorAll('.header__inline-menu details');

menus.forEach((detail) => {
  let openTimer;
  let closeTimer;

  detail.addEventListener('mouseenter', () => {
    clearTimeout(closeTimer);

    openTimer = setTimeout(() => {
      menus.forEach(menu => {
        if (menu !== detail) {
          menu.removeAttribute('open');
        }
      });

      detail.setAttribute('open', '');
    }, 150);
  });

  detail.addEventListener('mouseleave', () => {
    clearTimeout(openTimer);

    closeTimer = setTimeout(() => {
      detail.removeAttribute('open');
    }, 250);
  });
});

document.querySelectorAll('.header__inline-menu details summary').forEach((summary) => {
  summary.addEventListener('click', () => {
    if (summary.parentElement.hasAttribute('open')) {
      const link = summary.parentElement.querySelector('a');
      if (link) window.location.href = link.href;
    }
  });
});